import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import Piutang, { LaporanPiutangHalaman } from '../componen/piutang/Piutang';
import LayoutKasir from '../componen/kasir/layoutKasir';
import LayoutRetail from '../componen/kasir/retail/LayoutRetail';
import { Logout, reset } from '../fitur/AuthSlice';

const useLindungi = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);
  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);
  return navigate;
};

// Admin & superadmin: di dalam tata letak admin (sidebar / aplikasi admin).
export const PiutangPages = () => {
  useLindungi();
  return (
    <Layout>
      <Piutang />
    </Layout>
  );
};

// Laporan Piutang (menu Laporan): admin & superadmin.
export const LaporanPiutangPages = () => {
  useLindungi();
  return (
    <Layout>
      <LaporanPiutangHalaman />
    </Layout>
  );
};

// Kasir kafe: di dalam tata letak kasir.
export const PiutangKasirPages = () => {
  const navigate = useLindungi();
  const dispatch = useDispatch();
  const keluar = () => { dispatch(reset()); dispatch(Logout()); navigate('/'); };
  return (
    <LayoutKasir onNavigate={navigate} onLogout={keluar}>
      <Piutang />
    </LayoutKasir>
  );
};

// Kasir retail.
export const PiutangRetailPages = () => {
  useLindungi();
  return (
    <LayoutRetail>
      <Piutang />
    </LayoutRetail>
  );
};
